const ko_in_risks_page = {
  address: '주소',
  type: '종류',
};
const ko = {
  deposit: '입금',
  Deposit: '입금',
  withdraw: '출금',
  Withdraw: '출금',
  swap: '스왑',
  Swap: '스왑',
  pool: '풀',
  Pool: '풀',
  pools: '풀들',
  Pools: '풀들',
  view_pools: '풀들 보기',
  view_pool: '풀 보기',
  add_token: '토큰 더하기',
  create_new_pool: '새로운 풀 만들기',
  Create_New_Pool: '새로운 풀 만들기',
  your_liquidity: '당신의 유동성',
  Your_Liquidity: '당신의 유동성',
  farms: '농장',
  Farms: '농장',
  docs: '문서',
  account: '계정',
  Discord: '디스코드',
  Telegram: '텔레그렘',
  Twitter: '트위터',
  connect_to_near: 'NEAR에 연결하기',
  slippage: '슬리피지(미끄러짐) 허용치 ',
  minimum_received: '최소 수령양',
  swap_rate: '교환율',
  pool_fee: '풀 수수료',
  balance: '잔액',
  from: '(로)부터',
  to: '에게',
  submit: '제출',
  view_account: '계정 보기',
  liquidity: '유동성',
  tokens: '토큰',
  fee: '요금',
  fees: '요금',
  details: '세부 정보',
  detail: '세부 정보',
  minimum_tokens_out: '최소 입금량',
  pair: '쌍',
  tvl: 'TVL',
  add_liquidity: '유동성 더하기',
  remove_liquidity: '유동성 빼기',
  total_liquidity: '유동성 총합',
  my_shares: '지분',
  token: '토큰',
  enter_token_address: '토큰 주소 입력',
  remove: '제거',
  select: '선택',
  select_token: '토큰 선택',
  total_fee: '총 수수료% ',
  start_at: '에 시작',
  end_at: '에 종료',
  ended: '끝남',
  pending: '대기중',
  rewards_per_week: '주당 보상',
  apr: '연간이율',
  total_staked: '스테이킹 총합',
  unclaimed_rewards: '미수령 보상',
  claim: '수령',
  claim_all: '전부 수령',
  stake: '스테이킹 고정',
  unstake: '스테이킹 해제',
  your_shares: '지분',
  cancel: '취소',
  days: '일',
  slippageCopyForMobile:
    '슬리피지란 당신이 처음에 기대한 수익과, 다른 사람이 우선 실행되는 바람에 달라져버린 실제 수익의 차이를 말합니다. ',
  slippageCopy:
    '슬리피지란 당신이 처음 기대한 수익과 다른 사람이 우선 실행되는 바람에 달라져버린 실제 수익의 차이를 말합니다 ',
  swapCopy:
    '교환(스왑)은 첫 번째 선택된 토큰을 두 번째 선택된 토큰과 바꿉니다. 가장 유동성이 높고 수수료가 낮은 풀이 선택됩니다.',
  addTokenCopy: 'NEP-141 토큰을 더하세요',
  farmRewardsCopy:
    '지표 현 가격에 기반하였으며, 실제로 실행시 달라질 수 있습니다. ',
  you_do_not_have_enough: '양이 부족합니다',
  is_not_exist: '(은)는 존재하지 않습니다',
  must_input_a_value_greater_than_zero: '0보다 큰 값을 입력해야 합니다.',
  no_pool_available_to_make_a_swap_from:
    '교환(스왑) 가능한 풀이 존재하지 않습니다',
  for_the_amount: '에 해당하는 양',
  no_pool_eng_for_chinese: ' ',
  is_not_a_valid_swap_amount: '적합한 교환(스왑) 양이 아닙니다',
  not_nep_address:
    '입력한 주소가 NEP-141 주소가 아닙니다. 확인 후 다시 입력해 주세요. 만약 그 주소가 다른 메인넷의 계약을 가리킨다면, 브릿지 프로세싱을 위해 Rainbow Bridge로 이동하세요',
  not_correct_address:
    '당신이 입력한 주소는 잘못되었습니다. 확인 후 다시 입력해 주세요.',
  pool_id: '풀 ID',
  more_pools: '더 많은 풀',
  my_watchlist: '나의 워치리스트',
  h24_volume: '24시간 거래량',
  volume: '거래량',
  hide_low_tvl_pools: '잠금총액(TVL) 낮은 풀 숨기기',
  hide_low_tvl_pools_mobile: '잠금총액(TVL) 낮은 풀 숨기기',
  my_watchlist_copy: '워치리스트 된 유동성 풀은 여기에 등장합니다 ',
  language: '언어',
  deposit_to_add_liquidity: '유동성 추가를 위해 입금',
  slip_warn: '입금 가능한 최소량을 확인 후 신중히 결정하세요.',
  slip_invalid: '슬리피지(미끄러짐) 허용치가 적절한 수치가 아닙니다.',
  reward_tokens: '보상 토큰',
  detail_tip: '세부사항',
  no_data: '데이터 없음',
  attention: '*attention',
  live: '라이브',
  ended_search: '끝',
  my_farms: '당신의 이자 농장',
  sort_by: '(으)로 정렬',
  your_farms: '당신의 농장들',
  new: '최신',
  unstake_tip_t: '미수령 보상이 있습니다',
  unstake_tip_m:
    '스테이킹을 해제하면, 이 쌍과 관련된 현재의 활성화된 (혹은 예정된)농장들이 없어집니다',
  unstake_tip_b: '스테이킹을 해제하겠습니까?',
  value_rewards: '수령한 보상',
  stake_unstake_tip: '스테이킹 및 해제시 당신의 보상은 자동으로 수령됩니다',
  over_tip:
    '가스 수수료를 최적화하려면 최대 4개씩 토큰을 인출하는 것이 바람직합니다.',
  no_token_tip: '보상 토큰 없음',
  getToken_tip:
    '보상 토큰을 수령하거나, 유동성 풀의 토큰을 스테이킹 할 수 있습니다!.',
  in_farm: '농장 안',
  price_impact: '가격 영향',
  roi_calculator: 'ROI 계산기',
  lp_staked: 'LP 스테이킹 된',
  usd: 'USD',
  lp_token: 'LP 토큰',
  stake_for: '기간',
  day_1: '1일',
  day_2: '7일',
  day_3: '30일',
  day_4: '90일',
  cur_apr: 'ROI',
  reward_token: '토큰으로 보상하기',
  get_lp_token: 'LP 지분 받기',
  calculate_roi: 'ROI 계산기',
  rewards_claimed: '수령된 보상',
  value_rewards_token: '보상액',
  all: '전부',
  all_5: '한번에 최대 4토큰씩만',
  more_than: '0.01 이상의 숫자를 입력해 주세요',
  less_than: '20 이상의 숫자를 입력해 주세요',
  no_valid: '적절한 숫자를 입력해 주세요',
  lp_fee: 'LP 수수료',
  referral_fee: '추천 수수료 ',
  protocol_fee_referral_fee: '의정서 수수료 및 추천 수수료',
  total_fee_create: '총 수수료',
  ref: 'REF',
  are_you_sure: '확실히 실행하시겠습니까',
  price_impact_is_about: '가격 영향은 다음과 같은 사항에 관한 것입니다',
  yes_swap: '예, 스왑합니다',
  input_greater_than_available_shares: '가능한 지분보다 입력이 큽니다.',
  auto_router: '자동 라우터',
  optimal_path_found_by_our_solution: '우리 솔루션으로 찾은 최적의 경로',
  make_sure_you_understand_what_you_do:
    '당신이 무엇을 하는지 확실히 이해하기 바랍니다',
  filter_by: '(으)로 필터함',
  allOption: '전부',
  stablecoin: '스테이블코인',
  near_ecosystem: 'NEAR 생태계',
  bridged_tokens: '브릿지된 토큰',
  gaming: '게이밍',
  nft: 'NFT',
  bridge: '(으)로부터/(으로) 브릿지',
  no_result: '죄송합니다, 어떤 농장을 찾을 수 없었습니다.',
  multiple: '복수의',
  default: '기본값',
  create: '생성',
  select_a: '선택',
  wallet: '지갑',
  to_use_ref_finance: '{appName}를 사용하기 위해서는',
  not_supported: '지원되지 않음',
  installed: '설치됨',
  installe_now: '지금 설치',
  extension: '익스텐션',
  first_time_using_ref: '{appName}가 처음이신가요?',
  learn_more: '더 알아보기',
  install_sender_now: 'Sender를 설치하세요',
  connect_to_dapps_with_one_click: '클릭 한번에 dApps로 연결하세요',
  install: '설치',
  Connecting: '연결중',
  check_sender_wallet_extension: 'Sender Wallet extension을 다시 확인해 주세요',
  having_trouble: '문제가 있나요?',
  go_back: '뒤로가기',
  web: '웹',
  Type: '타입',
  click_to_view: '클릭하여 확인',
  transaction_failed: '트랜잭션 실패',
  wallet_vi: ' ',
  value: '가격',
  usd_value: 'USD 가격',
  initialize_account_tip: '당신의 계정을 초기화해 주세요.',
  support_ledger_tip:
    "레져는 메모리가 제한되는 구조 탓에 거대한 트랜잭션 양을 감당할 수 없습니다. (예: 오토 라우터 - 여러 풀에서 한번에 거래) 활성화시, '보조 장부' 옵션은 가장 간단한 형상으로 트랜잭션을 제한해서 합리적인 크기의 트랜잭션이 서명 될 수 있게 합니다. (오토 라우터에서 찾은 최적의 값보다 약간 손해를 볼 수 있습니다) ",
  start: '시작',
  max: '최대',
  ref_account_balance_tip:
    '유동성 풀에 추가하는/인출하는 과정에서 에러가 발생한 것 같습니다',
  ref_account_tip_2: 'Ref 계정에 토큰이 있습니다',
  ref_account_tip_top: '당신의 토큰은 아마 REF 내부 계정에 있을지도 모릅니다',
  click_here: '여기를 눌러',
  to_recover_them: '그것들을 회수하세요',
  ref_account_tip_3:
    'Ref 계정으로부터 NEAR 월렛으로 토큰을 인출하시려면 선택 후 인출을 눌러주세요',
  aurora_account_tip_4:
    '매핑 계정에서 NEAR 지갑으로 토큰을 인출하려면 선택하고 인출하십시오',
  buy: '구매',
  sell: '매각',
  rate: '요율',
  name: '이름',
  diff: '차이',
  best: '최상의',
  awesomeNear_verified_token: 'AwesomeNear 인증된 토큰입니다',
  pool_fee_apr: '풀 수수료 APY',
  ref_account_balance_tip_mobile: 'REF 계정에 토큰이 있습니다.',
  click: '딸깍 하는 소리',
  to_recover: '회복.',
  rewards_week: '주 당 보상',
  rewards: '보상',
  claimed_Rewards: '획득된 보상',
  POOL: '풀들',
  lp_Token: 'LP Tokens',
  booster: 'Booster',
  append: '추가',
  farm: '이자 농사짓기',
  status: '상태',
  Rewards: '보상',
  free: '공짜',
  lp_tokens: 'LP 토큰',
  connect_to_wallet: '지갑과 연결하기',
  slash_policy_content:
    '모든 시드는 각각의 슬래시 레이트가 있습니다. 이것은 시간이 지날수록 선형적으로 감소하다가, CD 계정의 unlock time에 0이 됩니다.',
  not_expired: '유효기간 남음',
  accept_pay_slash_tip: 'slash 지불에 동의합니다',
  i_will_pay: '지불하겠습니다',
  lp_token_slash: 'LP 토큰 엑싯 수수료.',
  expired: '만료됨',
  all_4_v2: '타임당 4 토큰',
  more_than_seed: '입력값은 다음보다 크거나 같아야 합니다:',
  how_to_earn_more: '보상을 복리로 받는 법?',
  lock_your_lp_tokens_with_booster:
    '당신의 LP 토큰을 잠가서(lock) 보상을 더 받으세요.',
  unstaked_anytime_no_booster: '언제든 언스테이킹 가능하지만, 부스터 없음',
  locking_stake: '잠금(Lock-up) 스테이킹',
  change_to_lock: '잠금(Lock-up) 스테이킹으로 변환',
  estimated_rewards: '예상된 보상 수치',
  final_booster: '최종 부스터',
  existing_amount: '존재하는 수량',
  append_amount: '수량 추가',
  will_be_able_to_unstaked_after: '다음 시간 뒤에 언스테이킹 가능합니다:',
  you_have: '당신이 가진 양: ',
  reward_apr: '보상 APR',
  stake_min_deposit: '입력된 값은 다음보다 크거나 같아야 합니다: ',
  unlock: '열기',
  exit_fee: '엑싯 수수료',
  end_locking_period: '잠금(locking) 기간 종료',
  add_lp_tokens_tip:
    '특정 농장에 스테이킹하려면 LP 토큰이 필요합니다. 우선 풀에 유동성을 공급하여 LP 토큰을 받으세요.',
  slash_tip:
    '엑싯 수수료 = 엑싯 수수료 요금rate * 잠금 종료까지의 기간* 잠금 수량',
  nonBoosted: '부스트 없음',
  exit_fee_tip: '잠금(lock-up)을 해제하는데 지불 비용 추정치',
  forbiddenTip: '이 농장은 이 기간 유형이 안됩니다.',
  unstakeTip:
    '스테이킹을 하면, 혹은 스테이킹을 해제하면 보상은 자동으로 획득됩니다.',
  endedFarmsUnstakeTip:
    '스테이킹 해제 시 모든 활성화된/펜딩된 농장에서 해당 쌍의 스테이킹이 해제됩니다.',
  comimg: '오고 있음',
  appendTip: '락킹 시점보다 더 이르게 할 수 없습니다.',
  week: '주',
  yours: '당신의',
  boost: '부스트',
  near: 'NEAR',
  eth: 'ETH',
  others: '기타',
  stakeLove: 'LOVE 스테이킹 하기',
  unstakeLove: 'LOVE 스테이킹 해제하기',
  get_love: 'LOVE 받기',
  swap_successful: '스왑에 성공했습니다. ',
  trading_successfull: '거래 성공. ',
  available_to_stake: '만큼 스테이킹이 가능',
  your_assets: '당신의 자산',
  connect_wallet: '지갑 연결',
  disconnect: '연결 해제',
  change: '변경하기',
  connect: '연결하기',
  veTip:
    'veLP 토큰은 거래/증여가 불가능합니다. veLPT는 당신의 투표권(voting power)을 나타냅니다 ',
  loveTip:
    'LOVE는 veToken의 유동성을 나타냅니다. 다른 NEP-141 토큰과 마찬가지로 LOVE는 거래/스왑/풀링/스테이킹/이자 농사 등이 다 가능합니다. LOVE는 당신의 veToken들의 기초 유동성(underlying liquidity)을 대표합니다 ',
  keep_ve: '킵해놓기 (keep)',
  months: '월',
  month: '월',
  lock_lp_tokens: 'LP Token 잠금',
  get_lptoken: 'LP Token 받기',
  duration: '기간',
  ve_lock_tip: '현재 잠금 해제일보다 더 이를 수 없음',
  get: '받기',
  you_have_no_lp_share: '당신은 LP Token이 없습니다',
  lock: '잠금',
  locked: '잠김',
  available: '가능함',
  in: 'in',
  filter: '필터',
  options: '옵션',
  ratio: '비율',
  back: '뒤로',
  confirm: '확인',
  total: '총합',
  type: '타입',
  connect_to_near_wallet: 'NEAR Wallet에 연결하기',
  v1Legacy: '구버전',
  v2New: 'Classic-신버전',
  v2_new_farms: 'Classic 신버전 농장',
  migrate_now: '지금 이주하세요!',
  v2_boost_tip:
    'Classic 농장에선 부스팅이 가능합니다. Legacy 농장들은 다음 날자 이후로 보상을 지급하지 않습니다: <span class="font-bold">2022년 8월 1일</span> ',
  v2_boost_no_tip:
    'Legacy 농장들은 다음 날자 이후로 보상을 지급하지 않습니다: <span class="font-bold">2022년 8월 1일</span> ',
  love: 'LOVE',
  Available_to_stake: '스테이킹 가능한 양은:',
  you_staked: '당신이 스테이킹한 양은:',
  has_rewards_tip_in_v2:
    '출금가능한 레거시 보상들이 기다립니다 <a rel="noopener noreferrer nofollow"  href="/farms" class="text-sm text-greenColor cursor-pointer underline ml-1 hover:text-senderHot"> Legacy Farms</a>.',
  how_to_get: '어떻게 받나요?',
  get_booster: '부스터 받기',
  ended_farms: '부스팅 종료된 농장',
  boosted_farms: '부스팅된 농장',
  your_farm: '당신의 농장',
  your_boosted_farms: '당신의 부스팅된 농장',
  search_farms_by_token: '토큰에 의해 농장 검색하기',
  search_farms: '농장 검색',
  more_lock_ve_popup2: 'more',
  left: '남음',
  create_pool: '풀 만들기',
  search_by_token: '토큰으로 검색',
  your_power: '당신의 "파워"',
  farm_has_boost_tip:
    '당신의 "파워" = 당신이 스테이킹한 LP 토큰 * 부스터 (부스터는 LOVE를 스테이킹하면 나옴)',
  farm_no_boost_tip: '당신의 "파워" = 당신이 스테이킹한 LP 토큰',
  more_than_a_simple_pool: '단순한 풀이 아니다',
  ended_Farms: '종료된 농장들',
  vote_capital: 'VOTE',
  boostFarmTip: 'LOVE를 스테이킹하고 부스터를 받으세요',
  boosted: '부스트 있음',
  love_staked: '스테이킹 된 LOVE',
  your_apr: '당신의 APR',
  range_apr: '범위, 혹은 참조 APR',
  no_pair_found: '쌍을 찾을 수 없습니다',
  found_stable_pool_in_sauce: 'SAUCE에서 안정적인 풀을 찾았습니다',
  lp_tokens_locking: 'LP 토큰',
  you_currently_have: '현재 가지고 있는',
  scheduled_to_be_unlocked: '잠금 해제 예정',
  locking_more_lp_tokens: '더 많은 LP 토큰 잠금',
  will_mean_these: '이것들을 의미할 것이다',
  lp_tokens_will_not_be_unlocked_until:
    'LP 토큰은 다음 시간까지 잠금 해제되지 않습니다',
  "I_understand_that_I_won't_be_able_to_remove_my":
    '내 계정을 삭제할 수 없음을 이해합니다',
  until: '~까지',
  add: '추가하다',
  finish: '마치다',
  add_custom_network: '사용자 지정 네트워크 추가',
  network_name: '네트워크 이름',
  rpc_name_taken_tip: '네트워크 이름은 이미 사용 중입니다',
  network_invalid: '네트워크가 잘못되었습니다',
  fobidden_testnet_rpc_tip:
    'RPC 서버의 네트워크(테스트넷)가 이 네트워크(메인넷)와 다릅니다',
  no_support_testnet_rpc_tip:
    '테스트넷은 사용자 지정 RPC 추가를 지원하지 않습니다',
  stable: 'Stable',
  limit: '한계',
  your_active_orders_will_appear_here: '당신의 현재 주문이 여기 있습니다',
  your_history_orders_will_appear_here: '당신의 과거 주문 내역이 여기 있습니다',
  farm_only: '농장만',
  please_confirm_this_transaction_on_ledger:
    'Ledger에서 이 거래를 확인하십시오.',
  limit_order: '주문 제한',
  farm_stop_tip: '이 농장은 중단되었습니다',
  pool_stop_tip: '이 풀은 중단되었습니다',
  volume_24h: '총 거래량 (24h)',
  add_to_watchlist: '와치리스트에 추가',
  remove_from_watchlist: '와치리스트에서 삭제',
  create_order: '오더 생성',
  filled: '처리됨',
  canceled: '취소됨',
  partially_filled: '일부 처리됨',
  pool_composition: '풀의 구성',
  amount: '수량',
  h24_volume_bracket: '총 거래량(24h)',
  fee_24h: '수수료 (24h)',
  orders: '명령',
  your_orders: '당신의 주문',
  active: '현재 진행중',
  history: '과거 내역',
  you_sell: '당신이 판',
  you_buy: '당신이 산',
  fee_tiers: '수수료 등급',
  created: '생성됨',
  executed: '실행됨',
  actions: '액션들',
  claimed_upper: 'Claimed',
  open_my_order: '나의 오픈 오더',
  initial_order: '최초 주문',
  this_order_has_been_partially_filled: '이 주문은 일부 처리되었습니다.',
  filled_via_swap: '스왑으로 주문 처리됨',
  state: '상태',
  partially: '부분적으로',
  near_validation_error: '가스비를 예비해서 0.5N 이상이 지갑에 있어야합니다.',
  near_min_validation_error:
    '가스비를 예비해서 0.2N 이상이 지갑에 있어야합니다.',
  no_positons_in_this_pool_yet: '이 풀에는 아직 포지션이 없습니다',
  no_claimed_rewards_yet: '수령된 보상이 없습니다',
  out_of: 'out of',
  fee_Tiers: '수수료 등급',
  no_pool: '풀 없음',
  input_amount: '입력 양',
  update_range: '업데이트 범위',
  not_enough_balance: '잔고 부족',
  set_price_range: '가격대 설정',
  current_price: '현재 가격',
  invalid_range_tip:
    '부적절한 가격대 선택됨. 최소 가격이 최대 가격보다 낮아야 합니다. ',
  maket_price_outside_single_only_tip:
    '시장 가격이 당신이 선택한 가격대 밖입니다. 자산 한개의 예치만 가능합니다.',
  min_price: '최소 가격',
  max_price: '최대 가격',
  min: '최소',
  out_of_range: '범위 넘김',
  in_range: '범위 맞음',
  unclaimed_fees: '안 찾아간 수수료들',
  your_position_will_be: '이 가격에서는: ',
  at_this_price: '이 당신의 포지션입니다',
  price_range: '가격대',
  positions: '포지션',
  position: '포지션',
  range: '범위',
  login_risk_tip:
    '여기에 체크하시면 {appName} 사용시의 리스크를 완전히 숙지하시고 진행하는 것으로 간주됩니다.',
  stable_pool: '스테이블 풀',
  market_rate: '시장 요율',
  no_token_found: '해당되는 토큰 없음',
  search_name_or_address: '이름을 검색하거나 주소를 붙여넣으세요...',
  token_address_invalid: '토큰 주소가 올바르지 않습니다',
  price_impact_warning: '가격 영향 경고',
  confirm_order: '구매 확정',
  you_Sell: '판매합니다',
  to_Buy: 'to Buy',
  at_Price: '이 가격에',
  insufficient_balance: '잔고 불충분',
  limitTip: '당신의 가격은 가장 가까운 가격 슬롯으로 맞춰집니다.',
  v2_pools: 'DCL 풀들',
  v2_your_pool_introduction: '당신의 분할된 집중화 유동성',
  v1_your_pool_introduction: '기존의 풀에 들어간 유동성',
  estimate_value: '가치 예상하기',
  price: '가격',
  '@price': '@Price',
  trades: '거래들',
  time: '시각',
  balances: '잔고',
  asset: '자산',
  action: '행위',
  market: '시장',
  Maker: '메이커',
  chart: '차트',
  refresh_data_to_continue: '계속 진행하려면 데이터를 새로고침하세요',
  refresh: '새로고침',
  both: '둘 다', //
  All: '전부',
  Filled: '체결됨',
  cancel_order: '주문 취소',
  instrument: 'Instrument',
  dex: 'Dex',
  limit_order_created: 'Limit Order 생성됨',
  limit_order_filled: 'Limit Order 체결됨',
  classic_pools: 'Classic 풀',
  active_orders: '활성화된 주문들',
  your_liquidity_usd_value: '당신의 유동성 (USD 기준)',
  usage: '사용',
  holding: '홀딩',
  your_lp_tokens_and_shares: '당신의 LP 토큰(지분)',
  swapped: '스왑됨',
  dcl_pool: 'DCL 풀',
  classic: 'Classic',
  classic_farms: 'Classic 농장들',
  locked_in: '다음에 잠겨 있음:',
  'deposit_near_tip_0.5':
    '예치하기 위해서는 가스 비용 처리를 위해 최소 0.5NEAR를 지갑에 남겨 두세요.',
  trade: '거래',
  earn_2: '얻다',
  portfolio: '포트폴리오',
  more_2: '더 보기',
  liquidity_pools_2: '유동성 풀',
  stable_pools: '스테이블 풀들',
  pool_detail: '풀 상세내역',
  new_contract_deploy_tip:
    '새로운 컨트랙트가 배포되었습니다! 이전 컨트랙트에서 유동성을 제거해주세요.',
  remove_will_automatically_claim:
    '유동성을 제거하면 미수령된 보상 수수료가 자동으로 수령됩니다.',
  legacy_tip: '스테이킹 안 된 LP 토큰 혹은 보상을 여기서 찾았습니다:',
  legacy_farms: '레거시 농장들',
  all_farms: '모든 농장들',
  your_farms_2: '당신의 농장들',
  dcl_farms: 'DCL 농장들',
  farm_type: '농장 유형',
  farm_2: '농사', //
  to_claim: '수령하려면',
  liquidity_staked: '유동성 스테이킹 됨',
  dcl_pool_detail: 'DCL Pool 상세',
  reward_range: '보상 범위',
  reward_range_tip: '농장 보상은 다음 범위 내입니다:',
  ending_soon: '곧 끝납니다',
  farm_ended_tip: '이 농장은 끝났습니다.',
  farm_will_ended_tip: '이 농장은 곧 끝납니다.',
  new_farm: '새 농장',
  is_coming: '개봉박두',
  est_apr: '예상 연이율(APR)',
  farming: '농사 중',
  unavailable: '불가능unavailable',
  hide: '숨기기',
  show: '보이기',
  your: '당신의',
  max_apr: '최대 연이율(APR)',
  you_can_earn_tip: '이자 농사로 보상을 얻을 수 있습니다! 예상되는 연 이율:',
  you_can_earn_current_tip:
    '당신이 스테이킹한 농장이 끝났습니다. 곧 새로운 농장이 옵니다. 예상되는 연 이율:',
  go_new_farm: '새 농장 가보기',
  go_farm: '농사하러 가기',
  in_ended_farm: '끝난 농장 안에',
  staked: '스테이킹 됨',
  in_farm_3: '농장 안에',
  estimation: '예상 가치',
  this_staked_tip: '이 NFT는 여기에 스테이킹 되었습니다',
  dcl_liquidity: 'DCL 유동성',
  classic_liquidity: 'Classic 농장 유동성',
  will_appear_here_tip: '당신의 유동성 포지션이 여기 나타납니다.',
  dcl_will_appear_here_tip: '당신의 DCL 유동성 포지션이 여기 나타납니다.',
  classic_will_appear_here_tip:
    '당신의 Classic 유동성 포지션이 여기 나타납니다.',
  price_range_overlap_ratio: ' 가격 범위 중첩 비율',
  real_time_executed_orders: '실시간 실행된 주문들',
  real_time_executed_orders_tip:
    '리미트 오더 기능으로 시장가 이상으로 판매 주문을 넣거나 시장가 이하로 구매 주문을 넣을 경우 {appName}는 우선 스톱포인트 있는 스왑(swap-with-stop-point) 액션을 먼저 실행한 뒤에, 남는 양이 있을 경우 리미트 오더를 체결할 것입니다. "실시간으로 실행된 주문(real time executed order)"은, 리미트 오더 기능을 통해 만들어졌으나 실제 실행은 스왑을 통해 거래된 주문을 말합니다. "과거 내역" 섹션에서, 당신은 최초의 표기된 리미트 오더부터 현재까지의 실시간 실행 주문을 볼 수 있습니다. ',
  swapped_history_order: '스왑됨?',
  ledger_guide_tip_1: 'Ledger 지갑을 트랜잭션에 성공적으로 사용하기 위해,',
  ledger_guide_tip_2: '이 기능이 자동으로 활성화 되었습니다.',
  ledger_guide_tip_3: '염두해 주세요',
  ledger_guide_tip_quote: '"',
  support_ledger_tip_new: '"Support Ledger"',
  ledger_guide_tip_4:
    'Ledger 지갑의 제약 때문에, 스왑 기능에서 현재 제공하는 요금이',
  ledger_guide_tip_5: '최상의 가격이 아닐 수 있습니다',
  ledger_guide_tip_6: '.',
  your_trade_route: '당신의 거래 루트',
  markets: '시장들',
  exchanges: '거래소들',
  output_est: 'Output (예상치.)',
  new_swap_order_tip:
    '가격의 출처는 {appName} AMM의 offer이며, 참고자료일 뿐입니다. 당신의 리미트 오더가 즉시 체결되리라는 보장은 없습니다',
  instants_swap: '즉시 스왑',
  swappped: '스왑됨',
  claimed: '수령됨',
  executing_capital: '실행중',
  trade_route: '거래 경로',
  settings: '설정',
  no_trade_routes: '거래 루트 안 사용하기',
  steps_in_the_route: '루트 내 각 단계들',
  swap_chart_no_data: '차트로 보일 데이터가 충분하지 않습니다.',
  last_updated: '최종 업데이트 일:',
  steps_in_the_route_zh: '',
  Burrow: 'Burrow',
  Supplied: '공급됨',
  APY: 'APY',
  size: '사이즈',
  assets: '산',
};
export default Object.assign(ko, ko_in_risks_page);
